import React, { useEffect, useState } from 'react';
import { Box, Alert, Typography, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const WebViewDetector = () => {
  const [isWebView, setIsWebView] = useState(false);
  const [isOpen, setIsOpen] = useState(true);
  
  useEffect(() => {
    // Detect WebView
    const detectWebView = () => {
      const userAgent = navigator.userAgent.toLowerCase();
      
      // LinkedIn WebView detection
      const isLinkedInWebView = userAgent.includes('linkedin') && 
                               !userAgent.includes('linkedin-app');
                               
      // Facebook WebView detection
      const isFacebookWebView = userAgent.includes('fban') || 
                               userAgent.includes('fbav');
                               
      // General WebView detection
      const isGenericWebView = userAgent.includes('wv') || 
                              (userAgent.includes('android') && !userAgent.includes('chrome'));
                              
      return isLinkedInWebView || isFacebookWebView || isGenericWebView;
    };
    
    setIsWebView(detectWebView());
  }, []);
  
  if (!isWebView || !isOpen) return null;
  
  return (
    <Box sx={{ position: 'fixed', top: 0, left: 0, right: 0, zIndex: 9999, p: 2 }}>
      <Alert 
        severity="warning" 
        variant="filled"
        action={
          <IconButton
            aria-label="close"
            color="inherit"
            size="small"
            onClick={() => setIsOpen(false)}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        }
      >
        <Typography variant="body2" fontWeight="medium">
          For the best experience with Google Sign-In, please open this app in your default browser
        </Typography>
      </Alert>
    </Box>
  );
};

export default WebViewDetector; 